import api from "./api";

// CREATE LISTING
export const createListing = async (data) => {
  try {
    const response = await api.post(
      "/product-listing-management/listings",
      data
    );

    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    }

    return { success: false, error: "Unexpected response" };
  } catch (error) {
    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to create listing",
    };
  }
};

// FETCH MY LISTINGS
export const fetchMyListings = async (page = 1, size = 10) => {
  try {
    const response = await api.get(
      `/product-listing-management/listings/my?page=${page}&size=${size}`
    );

    if (response.status === 200) {
      return { success: true, data: response.data.data };
    }

    return { success: false, error: "Unexpected response" };
  } catch (error) {
    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to fetch listings",
    };
  }
};

// UPDATE LISTING
export const updateListing = async (listingId, data) => {
  try {
    const response = await api.put(
      `/product-listing-management/listings/${listingId}`,
      data
    );

    if (response.status === 200) {
      return { success: true, data: response.data.data };
    }

    return { success: false, error: "Unexpected response" };
  } catch (error) {
    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to update listing",
    };
  }
};

// DELETE LISTING
export const deleteListing = async (listingId) => {
  try {
    const response = await api.delete(
      `/product-listing-management/listings/${listingId}`
    );

    if (response.status === 200) {
      return { success: true };
    }

    return { success: false, error: "Unexpected response" };
  } catch (error) {
    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to delete listing",
    };
  }
};